import React from 'react';
import { DecisionTreeQuestion } from '../../../../types';
import { QuestionStyle, Col } from 'pages/new-questions/styles/common';
import { SplitLayout, ContextCard, PanelCard } from '../SplitPanelLayout/styles';
import { QuestionCounter, FinalQuestionTitle } from './styles';
import { AnswerOptions } from '../AnswerOptions';

interface SinglePhaseViewProps {
  question: DecisionTreeQuestion;
  currentStep: any;
  currentIndex: number;
  totalSteps: number;
  selectedOption: number | null;
  onOptionClick: (optionId: number) => void;
  isReviewMode?: boolean;
}

export const SinglePhaseView: React.FC<SinglePhaseViewProps> = ({
  question,
  currentStep,
  currentIndex,
  totalSteps,
  selectedOption,
  onOptionClick,
  isReviewMode = false,
}) => {
  if (!currentStep) return null;

  return (
    <SplitLayout>
      <ContextCard>
        <QuestionStyle dangerouslySetInnerHTML={{ __html: question.case_context || '' }} />
      </ContextCard>

      <PanelCard>
        <Col width="100%">
          <QuestionCounter>
            Questão {currentIndex + 1} de {totalSteps}
          </QuestionCounter>
          <FinalQuestionTitle dangerouslySetInnerHTML={{ __html: currentStep.statement || '' }} />
          <AnswerOptions
            answers={currentStep.answers || []}
            selectedOption={selectedOption}
            onOptionClick={onOptionClick}
            showResults={isReviewMode}
          />
        </Col>
      </PanelCard>
    </SplitLayout>
  );
};
